export default {
  namespaced: true,
  state: {
    /**
     * アカウント毎の、閉じたバナー警告を記録する
     * warning_type: 警告のタイプ
     * service_contract_expired_at: 当該警告の対象となったライセンス期限時刻
     * @type {
     *   {
     *     [accountId: string]: {
     *       warning_type: string,
     *       service_contract_expired_at: number,
     *     }[]
     *   }
     * }
     */
    closedAccountWarnings_v1: {},
  },
  getters: {
    accountWarnings(state, getters, rootState, rootGetters) {
      const {
        account_warnings,
        account_id,
        service_contract_expired_at,
      } = rootGetters['api/result/accountInfo']

      if (!account_warnings) return [];
      if (account_warnings.length < 1) return [];

      const closedWarnings = state.closedAccountWarnings_v1[account_id] || []

      const activeWarnings = account_warnings.filter((w) => {
        const warningOnceClosed = closedWarnings
          .find(cw =>
          (cw.warning_type === w.warning_type
            && cw.service_contract_expired_at === service_contract_expired_at)
          )
        return !warningOnceClosed // 既に閉じた警告は除く
      })

      return activeWarnings.map((w) => {
        return {
          warning_type: w.warning_type,
          message: w.data.message,
          background_color: w.data.background_color,
          close_button_enabled: w.data.close_button_enabled,
          button_text: w.data.button_text,
          button_action: w.data.button_action,
        }
      })
    },
  },
  mutations: {
    addClosedWarning(state, { account_id, warning_type, service_contract_expired_at }) {
      const closedWarning = { warning_type, service_contract_expired_at }

      const curClosedWarnings = state.closedAccountWarnings_v1[account_id]

      if (!curClosedWarnings) {
        state.closedAccountWarnings_v1[account_id] = [closedWarning]
      }
      else{
        const newClosedWarnings = [
          closedWarning,
          ...curClosedWarnings
        ]
        state.closedAccountWarnings_v1[account_id] = newClosedWarnings
      }
      state.closedAccountWarnings_v1 = Object.assign({}, state.closedAccountWarnings_v1, state.closedAccountWarnings_v1)
    }
  },
  actions: {
    closeAccountWarning({commit, rootGetters}, warning_type) {
      const { account_id, service_contract_expired_at } = rootGetters['api/result/accountInfo']

      commit("addClosedWarning", { account_id, warning_type, service_contract_expired_at })
    }
  },
}
